module.exports = __webpack_public_path__ + "static/media/cherry4.2b8cdf99.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/svg/cherry4.svg
// module id = 1397
// module chunks = 0